module.exports = __webpack_public_path__ + "static/media/background-home.c02e7214.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/background/background-home.jpg
// module id = 5901
// module chunks = 0